import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useSecurityStatus } from '../../hooks/security';
import { getOperatorId, handleChange, handleError, trimField } from '../Shared/Functions';
import { MeVService } from '../../services/V2/keymaster';

export function UpdateUser({ show, onHide, fail, success }) {
    const { user, updateUser } = useSecurityStatus();
    const [newUser, setNewUser] = useState<any>();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    useEffect(() => setNewUser(user), [])// eslint-disable-line react-hooks/exhaustive-deps

    const resetHide = () => {
        setNewUser(null);
        onHide();
    }

    const submit = () => {
        setIsSubmitting(true)
        getOperatorId()
            .then((x:any) =>{
                MeVService.meVUpdateMe({
                        name: newUser.name ?? user.name,
                        username: newUser.username ?? user.username,
                        email: user.email
                    })
                    .then(u => {
                        updateUser && updateUser({
                            ...user, name: newUser.name,
                            username: newUser.username
                        })
                        success("User Updated")
                        resetHide()
                        setIsSubmitting(false)
                    })
                    .catch(err => {
                        err.message !=="Not Found" && fail(handleError(err))
                        setIsSubmitting(false)
                    })
            })
    }
    
    return <>
        <Dialog onClose={resetHide}
            open={show}>
            <DialogTitle>Update User Information</DialogTitle>
            <DialogContent>
                {isSubmitting ?
                    <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> : <form>
                        <TextField
                            onChange={e => handleChange(e, newUser, setNewUser)}
                            onBlur={e => trimField(e, newUser, setNewUser)}
                            margin="normal"
                            name="username"
                            label="Username"
                            type="text"
                            value={newUser?.username}
                            fullWidth
                        />
                    </form>}

            </DialogContent>
            <DialogActions className='user-info-buttons-group'>
                <>
                    <Button variant="outlined" onClick={resetHide} disabled={isSubmitting} style={{marginRight:"10px"}}>Cancel</Button>
                    <Button variant="contained" disabled={isSubmitting} onClick={submit}>Save</Button>
                </>
            </DialogActions>
        </Dialog>
    </>
}
